import useGetUserById from 'features/user/hooks/useGetUserById';
import PropTypes from 'prop-types';
import React from 'react';

import OrgName from './orgName';

function UserOrgName({ userId, noCache = false }) {
  const {
    data: user, isFetching, isError, error,
  } = useGetUserById(userId, noCache);

  if (isFetching) {
    return <span>{`${userId} (loading organization...)`}</span>;
  }

  if (isError) {
    return <span>{`${userId} (Error: ${error.message})`}</span>;
  }

  if (!user || !userId) {
    return <span>{`${userId} (User missing)`}</span>;
  }

  return <OrgName orgId={user.organization} />;
}

UserOrgName.propTypes = {
  userId: PropTypes.string.isRequired,
  noCache: PropTypes.bool,
};

export default UserOrgName;
